import styled from "styled-components";

import { Text } from "@otta/design";

export const CardText = styled(Text)`
  line-height: 1.6;
`;
